<!--
// app/pages/[region]/tournament.vue
-->
<script setup lang="ts">
import LayoutTournamentKwcClubs from "~/components/pages/region-tournament/LayoutTournamentKwcClubs.vue";
import { useRegions } from "~/composables/regions";
import LayoutTournamentKwcNations from "~/components/pages/region-tournament/LayoutTournamentKwcNations.vue";
import { useNuxtApp } from "#imports";

const { $t } = useNuxtApp();

const { isWorldCup, isNations } = useRegions();

definePageMeta({
  middleware: [
    "not-found-americas",
    "not-found-spain",
    "not-found-queens",
    "not-found-italy",
    "not-found-king-of-kings-nations",
    "not-found-brazil",
    "not-found-france",
    "not-found-germany",
    "not-found-mena",
  ],
});

useSeoMeta({
  title: $t("menuItem.tournament"),
  ogTitle: $t("menuItem.tournament"),
});
</script>

<template>
  <layout-tournament-kwc-clubs v-if="isWorldCup"></layout-tournament-kwc-clubs>
  <layout-tournament-kwc-nations v-else-if="isNations"></layout-tournament-kwc-nations>
  <section v-else></section>
</template>

<style scoped>
strong {
  @apply font-black;
}
</style>
